import React from 'react';
import { Box } from '@mui/material';
import { useChat } from './hooks/useChat';
import ChatBox from './components/ChatBox';
import ChatInput from './components/ChatInput';

const Chatbot = () => {
    const {
        messages,
        input,
        loadingAnswer,
        setInput,
        handleSend,
    } = useChat();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '90vh',
            width: '90%',
            margin: 'auto',
            bgcolor: 'background.default',
            boxShadow: 2,
            borderRadius: 2,
            overflow: 'hidden'
        }}>
            <ChatBox messages={messages} loadingAnswer={loadingAnswer} />
            <ChatInput
                input={input}
                setInput={setInput}
                handleSend={handleSend}
            />
        </Box>
    );
};

export default Chatbot;